module.exports = __webpack_public_path__ + "static/media/logout.261fc68a.svg";